import { Controller } from "@hotwired/stimulus";

// This controller asks the server for the break warnings the form's settings
// would raise each time a field changes. It swaps in only this list so the form
// itself, its focus, and anything typed meanwhile stay as they are. Because the
// form's own authenticity token is bound to the form's action, the request
// carries the page's token in a header instead.
export default class extends Controller {
  static values = { url: String };

  initialize() {
    this.refresh = this.refresh.bind(this);
  }

  connect() {
    this.form = this.element.closest("form");
    this.form?.addEventListener("change", this.refresh);
  }

  disconnect() {
    this.form?.removeEventListener("change", this.refresh);
    this.request?.abort();
  }

  async refresh() {
    this.request?.abort();
    const request = new AbortController();
    this.request = request;
    const data = new FormData(this.form);
    data.delete("_method");
    data.delete("form_action");

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: data,
        headers: {
          Accept: "text/html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content ?? "",
        },
        signal: request.signal,
      });
      if (response.ok) this.element.innerHTML = (await response.text()).trim();
    } catch (error) {
      if (error.name !== "AbortError") throw error;
    }
  }
}
